import React from 'react';
import { Spinner, Alert, Button } from 'react-bootstrap';

export const InfoRow = ({ label, value }) => (
    <div className="d-flex justify-content-between align-items-start py-1 border-bottom">
        <span className="text-muted small">{label}</span>
        <span className="small text-break ms-3 text-end" style={{ maxWidth: '60%' }}>{value ?? '—'}</span>
    </div>
);

const InfrastructureSectionPanel = ({ loading, error, onRefresh, children }) => {
    if (loading) {
        return (
            <div className="text-center py-4">
                <Spinner animation="border" size="sm" className="me-2" />
                <span className="text-muted small">Loading…</span>
            </div>
        );
    }
    if (error) {
        return (
            <Alert variant="danger" className="small mb-0">
                <i className="bi bi-exclamation-triangle me-1"></i>{error}
                <Button variant="link" size="sm" className="p-0 ms-2" onClick={onRefresh}>Retry</Button>
            </Alert>
        );
    }
    return children;
};

export default InfrastructureSectionPanel;
